import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllControleEnergiaUseCase } from "../../../presentation/useCases/read/get_all_controle_energia_use_case";
import {
  ControleEnergiaItemModel,
  GetAllControleEnergiaRequestModel,
  GetAllControleEnergiaResponseModel,
} from "../../models/obras_sustentabilidade_model";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllControleEnergiaUseCase
 */
export class GetAllControleEnergiaUseCase extends BasePaginatedUseCase<ControleEnergiaItemModel> implements IGetAllControleEnergiaUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllControleEnergia(model: GetAllControleEnergiaRequestModel): Promise<GetAllControleEnergiaResponseModel> {
    const response = await this.repository.getAllControleEnergia(model);

    // ainda mantém paginação e items pra uso do BasePaginatedUseCase
    this._items = response.itens.items;
    this._totalPages = response.itens.totalPages;
    this._totalItems = response.itens.totalItems;
    this._currentPage = response.itens.currentPage;
    this._pageSize = response.itens.pageSize;

    return response;
  }
}
